import { NvPusherSocketId } from './nv-pusher-interceptor';
import { Injectable } from '@angular/core';
import { PortalConfig } from '../portal-config';
import { WindowRef } from '../windowRef';
import { Auth } from '../../auth/auth.service';
import * as Pusher from 'pusher-js/with-encryption';

/* istanbul ignore next */
@Injectable()
export class PusherService {
  // Pusher as any is used to prevent the following compilation error:
  // https://stackoverflow.com/questions/48115003/how-to-use-pusher-js-within-vs-codes-angular-workflow (Carlos)
  private _Pusher = Pusher as any;
  private _pusher: Pusher.default;

  constructor(private auth: Auth, private windowRef: WindowRef, private portalConfig: PortalConfig) {}

  get pusher() {
    if (!this._pusher) this._pusher = this.initializeClient();

    return this._pusher;
  }

  private get channelNamePrefix() {
    const { publicConfig } = this.portalConfig;
    // Encrypted channels must be prefixed with 'private-encrypted-' (Carlos)
    // More info: https://pusher.com/docs/channels/using_channels/encrypted-channels
    if (publicConfig.PUSHER_ENCRYPTION_ENABLED) return 'private-encrypted-school';
    // enable encryption
    else return 'private-school'; // disable encryption
  }

  getChannelName(schoolId) {
    const channelNamePrefix = this.channelNamePrefix;
    const pusherChannelName = `${channelNamePrefix}-${schoolId}`;

    return pusherChannelName;
  }

  private initializeClient() {
    const { publicConfig } = this.portalConfig;
    const karmaIsRunning = this.windowRef.nativeWindow._KARMA_IS_RUNNING;
    if (publicConfig.DEV_MODE && !karmaIsRunning) this._Pusher.logToConsole = true;

    if (karmaIsRunning) {
      throw new Error(
        `Some service tried to initialize PusherService while tests are running. This will cause us to bump up ` +
          `against our Pusher connection limit.\nInstead of doing that, import PusherServiceMock into your test.`,
      );
    }

    const pusher = new this._Pusher(publicConfig.PUSHER_KEY, {
      authEndpoint: publicConfig.NV_API_ORIGIN + '/v1/pusher/auth',
      encrypted: true,
      auth: {
        headers: {
          Authorization: this.auth.getIdToken(),
        },
      },
    });
    // How should we handle this error if pusher fails to connect?
    // Do we alert the client or proceed without realtime updates?
    pusher.connection.bind('connected', () => {
      NvPusherSocketId.setSocketId(pusher.connection.socket_id);
    });

    return pusher;
  }
}
